export const GetEventLink = (competition) => {
    if (competition?.eventNumber) {
        return '/' + competition.eventNumber
    } else {
        return `/${
            competition?.buttonLink?.url ? competition.buttonLink.url : `${competition?.name?.replace(' ', '-')}`
        }`
    }
}

export const GetConfigurationEventLink = (competition) => {
    if (competition?.eventNumber) {
        return '/' + competition.eventNumber + '/configuration'
    } else {
        return GetEventLink(competition)
    }
}

export const GenerateHexString = (length = 15) => {
    var ret = ''
    while (ret.length < length) {
        ret += Math.random().toString(16).substring(2)
    }
    return ret.substring(0, length)
}
